import React, {
  useMemo,
} from 'react';
import {
  useHistory,
} from 'react-router-dom';

import {
  Flex,
} from 'web-styled';

import Tag from './styled';

type Props = {
  tags: string[],
  resourceType: string,
};

const TagList = ({ tags, resourceType }: Props) => {
  const history = useHistory();
  const sorted = useMemo(() => (tags ? tags.sort() : []), [tags]);
  return tags ? (
    <Flex
      wrap="wrap"
      align="center"
      spacing={6}
    >
      {sorted.map((tag: string) => (
        <Tag
          key={tag}
          onClick={() => history.push(`/tags/${tag}/${resourceType}?back=${window.location.pathname}`)}
        >
          {tag}
        </Tag>
      ))}
    </Flex>
  ) : null;
};

export default TagList;
